import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from './error.component';

const routes: Routes = [
    {path :'error-status-500',component:ErrorComponent},
    {path :'error-status-500/:id',component:ErrorComponent},
    {path :'error-status-403',component:ErrorComponent},
    {path :'error-status-401',component:ErrorComponent},
    {path :'error-status-404',component:ErrorComponent},
    {path :'error-status-400',component:ErrorComponent},
    {path :'internal-error',component:ErrorComponent},
  ];
  
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ErrorRoutingModule { }
